import { getCurrencyFormatter } from "@redotech/money/util";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useMemo } from "react";
import type { OrderWithPickStatus } from "../db/collections";
import { ConversationTicketFieldTitle } from "./conversation-ticket-field-title";

export const CustomerTotals = memo(function CustomerTotals({
  orders,
  pending,
}: {
  orders: OrderWithPickStatus[];
  pending: boolean;
}) {
  const { totalSpent, totalOrders, currency } = useMemo(() => {
    if (!orders.length) {
      return { totalSpent: 0, totalOrders: 0, currency: "USD" };
    }

    const total = orders.reduce((sum, order) => {
      const orderTotal =
        order.shopify.current_total_price ??
        order.shopify.total_price_usd ??
        order.shopify.total_price;
      return sum + Number(orderTotal);
    }, 0);

    // Use the currency from the first order (all orders should be in same currency for a customer)
    const orderCurrency = orders[0]?.shopify.presentment_currency || "USD";

    return {
      totalSpent: total,
      totalOrders: orders.length,
      currency: orderCurrency,
    };
  }, [orders]);

  const formattedTotal = pending
    ? "-"
    : getCurrencyFormatter(currency).format(totalSpent);

  return (
    <>
      <Flex align="center" gap="md" justify="space-between">
        <ConversationTicketFieldTitle>Total spent</ConversationTicketFieldTitle>
        <Text fontSize="xs" textColor="primary">
          {formattedTotal}
        </Text>
      </Flex>
      <Flex align="center" gap="md" justify="space-between">
        <ConversationTicketFieldTitle>
          Total orders
        </ConversationTicketFieldTitle>
        <Text fontSize="xs" textColor="primary">
          {pending ? "-" : totalOrders}
        </Text>
      </Flex>
      <Flex align="center" gap="md" justify="space-between">
        <ConversationTicketFieldTitle>
          Total returns
        </ConversationTicketFieldTitle>
        <Text fontSize="xs" textColor="primary">
          -
        </Text>
      </Flex>
    </>
  );
});
